import React from 'react'
let PropTypes = React.PropTypes

import api from '../../apiClient/v1'

import { ModalTrigger, ModalReporteInicial, ModalReporteAvance, ModalReporteFinal } from './Modales.jsx'
import { TablaReportes } from './TablaReportes.jsx'

import classNames from 'classnames/bind'
import * as css from './ReporteInventario.css'
import TarifaNomina from '../tarifa/TarifaNomina.jsx'

let cx = classNames.bind(css)

export class ReporteInventario extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            idInventario: this.props.idInventario,
            nomina: this.props.nomina,
            inventario: [],
            reportes: [],
            totalReportes: 0,
            dotacion: 0
        }
        this.fetchInventario = ()=>{
            api.api().misInventariosDia(this.state.idInventario)
                .then(resp =>{
                    this.setState({ inventario: resp.result[0] })
                })
                .catch(err =>{
                    console.log(err)
                })
        }
        this.fetchReportes = ()=>{
            api.api().misReportesInventario(this.state.idInventario)
                .then(resp=>{
                    this.setState({ 
                        reportes: resp.result,
                        dotacion: resp.result[0]? resp.result[0].dotacion : 0,
                        totalReportes: resp.result.length
                    })
                })
                .catch(err =>{
                    console.log(err)
                })
        }
    }
    getChildContext(){
        return{
            nuevaMarca: (datos)=>{
                let request = api.api().misReportesNuevo(datos.idInventario, datos.tipo, datos.hora, datos.dotacion, datos.avance, datos.error, datos.comentario, datos.auditoria, datos.idDescripcionReportesIG, datos.idDescripcionReportesLocal)
                request
                    .then(resp=>{
                        this.fetchReportes()
                    })
                    .catch(err=>{
                        console.log(err)
                    })
                return request
            },
            descripcionReportes: (tipo, subTipo)=>{
                let request = api.api().descripcionReportes(tipo, subTipo)
                request
                    .then(resp=>{
                        this.fetchReportes()
                    })
                    .catch(err=>{
                        console.log(err)
                    })
                return request
            },
            nuevoAnexoMarca: (idMarca, estado_deterioro, sku_deterioro, estado_pago, foto_avance)=>{
                let request = api.api().nuevoAnexoMarca(idMarca, estado_deterioro, sku_deterioro, estado_pago, foto_avance)
                request
                    .then(resp=>{
                        this.fetchReportes()
                    })
                    .catch(err=>{
                        console.log(err)
                    })
                return request
            },
            updateNomina : (nomina) => {
                this.setState({nomina})
            }
        }
    }

    componentWillMount(){
        this.fetchInventario()
        this.fetchReportes()
    }
    render() {
        return (
            <div>
                <div className="col-md-6 col-sm-12">
                    <div className="row">
                        <div className="panel panel-primary">
                            <div className="panel-heading">Detalle Inventario</div>
                            <div className="panel-body">
                                <div className={cx("form-group", 'form-group-padding')}>
                                    <div className="col-md-6 col-sm-6">
                                        <label className="col-md-7 col-sm-4 control-label">Fecha Programada:</label>
                                        <label className={cx("col-md-5 col-sm-2 ",'label-text')}>{this.state.inventario.fechaProgramada}</label>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <label className="col-md-7 col-sm-4 control-label">Turno:</label>
                                        <label className={cx("col-md-5 col-sm-2 ",'label-text')}>{this.state.inventario.jornada}</label>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <label className="col-md-7 col-sm-2 control-label">Hr. Llegada:</label>
                                        <label className={cx("col-md-5 col-sm-2 ",'label-text')}>{this.state.inventario.hrLider}</label>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <label className="col-md-7 col-sm-2 control-label">Hr. Llegada Equipo:</label>
                                        <label className={cx("col-md-5 col-sm-2 ",'label-text')}>{this.state.inventario.hrEquipo}</label>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <label className="col-md-7 col-sm-2 control-label">Dotación:</label>
                                        <label className={cx("col-md-5 col-sm-2 ",'label-text')}>{this.state.inventario.dotacion}</label>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <label className="col-md-7 col-sm-2 control-label">Stock Teórico:</label>
                                        <label className={cx("col-md-5 col-sm-2 ",'label-text')}>{this.state.inventario.stockTeorico}</label>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <label className="col-md-7 col-sm-2 control-label">Cliente:</label>
                                        <label className={cx("col-md-5 col-sm-2 ",'label-text')}>{this.state.inventario.nombreCliente}</label>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <label className="col-md-2 col-sm-2 control-label">Local:</label>
                                        <label className={cx("col-md-10 col-sm-2 ",'label-text')}>{this.state.inventario.nombreLocal}</label>
                                    </div>
                                    <div className="col-md-12 col-sm-12">
                                        <label className="col-md-3 col-sm-2 control-label">Dirección:</label>
                                        <label className={cx("col-md-6 col-sm-6 ",'label-text')}>{this.state.inventario.direccionLocal}</label>
                                    </div>
                                    <div className="col-md-12 col-sm-12">
                                        <label className="col-md-3 col-sm-1 control-label">Región:</label>
                                        <label className={cx("col-md-3 col-sm-1 ",'label-text')}>{this.state.inventario.region}</label>
                                        <label className="col-md-3 col-sm-1 control-label">Provincia:</label>
                                        <label className={cx("col-md-3 col-sm-3 ",'label-text')}>{this.state.inventario.provincia}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12">
                    <div className="panel panel-info">
                        <div className="panel-heading">Mis Reportes</div>
                        <div className="panel-body">
                            <TablaReportes
                                reportes={this.state.reportes}
                            />
                        </div>
                    </div>
                </div>
                <div className={cx("col-md-12 col-sm-12", 'center-btn')}>
                    <div style={{marginRight: 10}}><TarifaNomina nomina={this.state.nomina} /> </div>
                    <BotonReporte
                        idInventario={this.state.idInventario}
                        totalReportes={this.state.totalReportes}
                        dotacion={this.state.dotacion}
                    />
                    <a className={cx("btn btn-default btn-md", 'btn-cancel')} href="/">Cancelar</a>
                </div>
            </div>
        )
    }
}
const BotonReporte = ({idInventario, totalReportes, dotacion}) =>
    {
        if (totalReportes==0) {
            return <ModalTrigger>
                {(isVisible, showModal, hideModal)=>
                    <button className={cx("btn btn-md btn-primary", 'btn-reporte')} onClick={showModal}>
                        Reporte Inicial
                        {isVisible && <ModalReporteInicial
                            hideModal={hideModal}
                            idInventario={idInventario}
                        />}
                    </button>
                }
            </ModalTrigger>
        }else if (totalReportes==1) {
            return <ModalTrigger>
                {(isVisible, showModal, hideModal)=>
                    <button className={cx("btn btn-md btn-primary", 'btn-reporte')} onClick={showModal}>
                        Reportar Avance
                        {isVisible && <ModalReporteAvance
                            hideModal={hideModal}
                            idInventario={idInventario}
                            dotacion={dotacion}
                        />}
                    </button>
                }
            </ModalTrigger>
        } else if (totalReportes==2) {
            return <ModalTrigger>
                {(isVisible, showModal, hideModal)=>
                    <button className={cx("btn btn-md btn-primary", 'btn-reporte')} onClick={showModal}>
                        Reporte Final
                        {isVisible && <ModalReporteFinal
                            hideModal={hideModal}
                            idInventario={idInventario}
                            dotacion={dotacion}
                        />}
                    </button>
                }
            </ModalTrigger>            
        }else{
            return <button className={cx("btn btn-md btn-default", 'btn-reporte')}>Reportes Finalizados</button>
        }
    }
    
ReporteInventario.childContextTypes = {
    nuevaMarca: PropTypes.func,
    descripcionReportes: PropTypes.func,
    nuevoAnexoMarca: PropTypes.func,
    updateNomina: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/api/reportes/ReporteInventario.jsx